import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";

process.env.NODE_ENV === "production" &&
  Sentry.init({
    dsn: "https://cf28712370874d3393fa48ecb3778d58@o1229638.ingest.sentry.io/4504162211201024",
    release: "1.0.1",
    maxBreadcrumbs: 50,
    debug: true,
    tracesSampleRate: 1.0,
  });

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
